module.exports = __webpack_public_path__ + "static/media/rocketIcon.6e73f1bb.svg";